View
<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
        {{ messHeader }}
        </p>
      </section>
      <section class="mgt-10px">
        <b-field :label="dateTitle"
          class="mgt-20px">
          <b-datepicker show-week-number
              icon="calendar-today"
              :editable="true"
              nearby-selectable-month-days
              v-model="dateFace">
          </b-datepicker>
        </b-field>
      </section>
      <footer class="mgt-10px">
        <div class="has-text-centered">
        <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$emit('close')">
            {{ $t('general.non') }}
        </button>
        <button class="button is-primary has-text-centered button-modal"
                @click="$emit('yes', dateFace)">
            {{ $t('general.oui') }}
        </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dateTitle: {
      type: String,
      required: true,
    },
    messHeader: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dateFace: new Date(),
    };
  },
};
</script>
